export const LOADING_WORKFLOWBLOCK_CHECKLISTS = 'LOADING_WORKFLOWBLOCK_CHECKLISTS';
export const LOADING_WORKFLOWBLOCK_CHECKLIST = 'LOADING_WORKFLOWBLOCK_CHECKLIST';
export const SAVE_LOADING_WORKFLOWBLOCK_CHECKLIST = 'SAVE_LOADING_WORKFLOWBLOCK_CHECKLIST';
export const GET_WORKFLOWBLOCK_CHECKLISTS = 'GET_WORKFLOWBLOCK_CHECKLISTS';
export const GET_WORKFLOWBLOCK_CHECKLIST = 'GET_WORKFLOWBLOCK_CHECKLIST';
export const WORKFLOWBLOCK_CHECKLIST_FAIL = 'WORKFLOWBLOCK_CHECKLIST_FAIL';
export const WORKFLOWBLOCK_CHECKLIST_FORM_FAIL = 'WORKFLOWBLOCK_CHECKLIST_FORM_FAIL';
export const SAVE_LOADING_WORKFLOW_CHECKLIST_POSITION = 'SAVE_LOADING_WORKFLOW_CHECKLIST_POSITION';
